var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVersatileSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_51",
    "data-name": "Layer 51",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #15233f;\n      }\n\n      .cls-3 {\n        fill: #c2c7cc;\n        opacity: .25;\n      }\n\n      .cls-4 {\n        fill: #0f1a31;\n      }\n\n      .cls-5 {\n        fill: #4f7fff;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 250,
    cy: 250,
    r: 162.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25,
    y: 184.22,
    width: 131.55,
    height: 131.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 174.2,
    y: 184.22,
    width: 131.55,
    height: 131.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 330.85,
    y: 184.22,
    width: 131.55,
    height: 131.55
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M180.16,365.67l108.23-108.23c-26.17-39.5-21.86-93.24,12.95-128.05,39.73-39.73,104.14-39.73,143.87,0,39.73,39.73,39.73,104.14,0,143.87-34.8,34.8-88.54,39.12-128.05,12.95l-108.23,108.23c-7.95,7.95-20.83,7.95-28.77,0-7.95-7.95-7.95-20.83,0-28.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.28,255.31c29.84,29.78,78.15,29.78,107.93,0,29.78-29.84,29.78-78.15,0-107.93-29.78-29.78-78.09-29.78-107.93,0-29.78,29.78-29.78,78.09,0,107.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVersatileSearch);
export default __webpack_public_path__ + "static/media/icon_versatile_search.e876228bd790af0401874de05acb65f5.svg";
export { ForwardRef as ReactComponent };